import { ListOutput } from '@allocab/allocab-commons-shared-types';
import { DocumentItemOutput } from '@allocab/allocab-driver-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchVehicleDocuments = (vehicleId: string) =>
  driverApi.get<void, DocumentItemOutput, 'list'>(`/v1/document/vehicle/${vehicleId}`);

export const useFetchVehicleDocuments = (
  vehicleId: string,
  options: QueryOptions<typeof queryKeys.user.fetchVehicleDocuments, ListOutput<DocumentItemOutput>> = {},
) => useQuery(queryKeys.user.fetchVehicleDocuments(vehicleId), () => fetchVehicleDocuments(vehicleId), { ...options });
